import React from 'react'
import {
	Box, Card, CardHeader, Typography, Table, TableHead, TableBody, TableRow, TableCell,
	IconButton, Grid, Chip
} from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'


const DEMO_CONDITIONS = [
	{
		name: 'Spain Cheaper Alert',
		mainSite: 'rentalspot.demo',
		mainProviders: 'AutoRent, DrivePro',
		comparison: { icon: 'chart-line-down', label: 'Cheaper', value: 15, unit: '%', color: '#2e7d32' },
		sites: 'pricefly.demo, eurodrive.demo',
		providers: 'Any',
	},
	{
		name: 'UK Price Diff Monitor',
		mainSite: 'eurodrive.demo',
		mainProviders: 'SpeedCar',
		comparison: { icon: 'chart-line-up-down', label: 'Difference', value: 20, unit: '$', color: '#1976d2' },
		sites: 'rentalspot.demo',
		providers: 'SpeedCar, PrimeFleet',
	},
	{
		name: 'France Expensive Check',
		mainSite: 'pricefly.demo',
		mainProviders: 'Any',
		comparison: { icon: 'chart-line-up', label: 'More Expensive', value: 25, unit: '%', color: '#d32f2f' },
		sites: 'Same sites',
		providers: 'Velocar, FleetMax',
	},
	{
		name: 'Germany Economy Alert',
		mainSite: 'bookride.demo',
		mainProviders: 'PrimeFleet, Velocar',
		comparison: { icon: 'chart-line-down', label: 'Cheaper', value: 10, unit: '$', color: '#2e7d32' },
		sites: 'autolink.demo',
		providers: 'Any',
	},
]

const LEGEND = [
	{ icon: 'percent', label: 'Percentage' },
	{ icon: 'money-bills', label: 'Currency' },
	{ icon: 'chart-line-down', label: 'Cheaper', color: '#2e7d32' },
	{ icon: 'chart-line-up', label: 'More Expensive', color: '#d32f2f' },
	{ icon: 'chart-line-up-down', label: 'Price Difference', color: '#1976d2' },
]


export default function ConditionsDemoData() {
	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Card>
				<Box sx={{ display: 'flex', justifyContent: 'center', py: 2, gap: 3 }}>
					{LEGEND.map((l, idx) => (
						<Box key={idx} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
							<IconSeeker icon={l.icon} sx={{ fontSize: 16, color: l.color || 'text.primary', mb: 0.3 }} />
							<Typography variant="caption" fontWeight={600}>{l.label}</Typography>
						</Box>
					))}
				</Box>

				<Box sx={{ px: 2, pb: 2, overflowX: 'auto' }}>
					<Table size="small">
						<TableHead>
							<TableRow sx={{ '& th': { bgcolor: 'primary.main', color: 'white', fontWeight: 600, fontSize: '0.75rem', whiteSpace: 'nowrap' } }}>
								<TableCell>Condition Name</TableCell>
								<TableCell>Main Site</TableCell>
								<TableCell>Main Providers</TableCell>
								<TableCell align="center">Comparison</TableCell>
								<TableCell>Sites</TableCell>
								<TableCell>Providers</TableCell>
								<TableCell align="center">Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{DEMO_CONDITIONS.map(c => (
								<TableRow key={c.name} sx={{ '& td': { py: 1.5, fontSize: '0.8rem' } }}>
									<TableCell>
										<Typography variant="body2" fontWeight={500}>{c.name}</Typography>
									</TableCell>

									<TableCell>
										<Chip label={c.mainSite.replace('.com', '')} size="small" sx={{ height: 22, fontSize: '0.7rem' }} />
									</TableCell>

									<TableCell>
										<Typography variant="caption">{c.mainProviders}</Typography>
									</TableCell>

									<TableCell align="center">
										<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
											<IconSeeker icon={c.comparison.icon} sx={{ fontSize: 14, color: c.comparison.color }} />
											<Typography variant="body2" fontWeight={600} sx={{ color: c.comparison.color }}>
												{c.comparison.value}{c.comparison.unit === '%' ? '%' : ''}
											</Typography>
											{c.comparison.unit !== '%' && (
												<IconSeeker icon="money-bills" sx={{ fontSize: 12, color: 'text.secondary' }} />
											)}
										</Box>
									</TableCell>

									<TableCell>
										{c.sites === 'Same sites'
											? <Typography variant="caption" color="primary" fontWeight={500}>Same sites</Typography>
											: <Typography variant="caption">{c.sites}</Typography>}
									</TableCell>

									<TableCell>
										<Typography variant="caption">{c.providers}</Typography>
									</TableCell>

									<TableCell align="center">
										<Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
											<IconButton size="small" title="Edit the alert">
												<IconSeeker icon="pen" size="xs" style={{ color: '#ed6c02' }} />
											</IconButton>
											<IconButton size="small" title="Delete the alert">
												<IconSeeker icon="trash-can" size="xs" style={{ color: '#d32f2f' }} />
											</IconButton>
										</Box>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</Box>
			</Card>
		</Grid>
	</Grid>
}
